<p class="lead">Zapisz się!</p>
<app-loading class="absolute" *ngIf="sending"></app-loading>
<form [formGroup]="newsletterForm" (ngSubmit)="onSubmit()">
  <div class="form-group">
    <label for="email" class="label">Adres email</label>
    <input type="text" class="field" formControlName="email" id="email" />
    <div class="errors">
      <small *ngIf="newsletterForm.get('email').hasError('required')">Pole jest wymagane</small>
      <small *ngIf="newsletterForm.get('email').hasError('pattern')">Podaj prawidłowy adres e-mail</small>
      <div *ngIf="newsletterForm.get('email').hasError('backend')">
        <small *ngFor="let error of newsletterForm.get('email').errors['backend'] | keyvalue">
          {{ error.value }}
        </small>
      </div>
    </div>
  </div>


  <div class="form-group">
    <input type="checkbox" class="field field--checkbox" formControlName="manager" id="manager" />
    <label for="manager" class="label">Jestem właścicielem/menadżerem salonu</label>
    <div class="errors">
      <small *ngIf="newsletterForm.get('manager').hasError('required')">Pole jest wymagane</small>
      <small *ngIf="newsletterForm.get('manager').hasError('pattern')">Podaj prawidłowy adres e-mail</small>
      <div *ngIf="newsletterForm.get('manager').hasError('backend')">
        <small *ngFor="let error of newsletterForm.get('manager').errors['backend'] | keyvalue">
          {{ error.value }}
        </small>
      </div>
    </div>
  </div>

  <div class="form-group">
    <input type="checkbox" class="field field--checkbox" formControlName="hairdresser" id="hairdresser" />
    <label for="hairdresser" class="label">Jestem Fryzjerem</label>
    <div class="errors">
      <small *ngIf="newsletterForm.get('hairdresser').hasError('required')">Pole jest wymagane</small>
      <small *ngIf="newsletterForm.get('hairdresser').hasError('pattern')">Podaj prawidłowy adres e-mail</small>
      <div *ngIf="newsletterForm.get('hairdresser').hasError('backend')">
        <small *ngFor="let error of newsletterForm.get('hairdresser').errors['backend'] | keyvalue">
          {{ error.value }}
        </small>
      </div>
    </div>
  </div>

  <div class="form-group">
    <input type="checkbox" class="field field--checkbox" formControlName="rulez" id="rulez" />
    <label for="rulez" class="label">Akceptuję <a href="/download-file/salonexpert-regulamin-newsletter" target="_blank">regulamin</a> newslettera marki Salon Expert</label>
    <div class="errors">
      <small *ngIf="newsletterForm.get('rulez').hasError('required')">Pole jest wymagane</small>
      <small *ngIf="newsletterForm.get('rulez').hasError('pattern')">Podaj prawidłowy adres e-mail</small>
      <div *ngIf="newsletterForm.get('rulez').hasError('backend')">
        <small *ngFor="let error of newsletterForm.get('rulez').errors['backend'] | keyvalue">
          {{ error.value }}
        </small>
      </div>
    </div>
  </div>

  <p>
    <small>
        Administratorem Pani/Pana danych osobowych jest L’Oréal Polska Sp. z o.o., z siedzibą w Warszawie (00-844) przy ul. Grzybowskiej 62. Kontakt z Inspektorem Ochrony Danych możliwy jest za pośrednictwem adresu e-mail: personal-da@loreal.com. Przetwarzanie danych osobowych będzie się odbywać w ramach udzielonej przynajmniej jednej zgody na kontakt w celach marketingu bezpośredniego – na podstawie z art. 6 ust. 1. lit. a Rozporządzenia Ogólnego o Ochronie Danych Osobowych (dalej RODO). Ma Pani/Pan prawo żądania dostępu do danych, sprostowania, usunięcia lub ograniczenia ich przetwarzania oraz wycofania zgody na przetwarzanie danych w celach marketingowych. Chce Pani/Pan uzyskać więcej informacji o tym jak L’Oréal Polska Sp. z o.o., przetwarza Pani/Pana dane osobowe? <button class="info" (click)="collapseInfo = !collapseInfo">{{ collapseInfo ? 'Więcej' : 'Mniej' }}</button>
    </small>
    <small *ngIf="!collapseInfo">
        W ramach realizacji celu marketingu bezpośredniego – dane zebrane na podstawie z art. 6 ust. 1. lit. a RODO mogą być wykorzystane w procesie profilowania, którego celem jest jak najlepsze dopasowanie przesyłanych informacji do Pani/Pana potrzeb i zainteresowań (art. 6 ust. 1 lit. f RODO). Pani/Pana dane mogą być przekazane podmiotom przetwarzającym je na nasze zlecenie, ale tylko w celu i zakresie niezbędnym dla realizacji ww. celu m. in. podmiotom świadczącym na naszą rzecz usługi IT oraz podmiotom wspierającym działania marketingowe, przy czym takie podmioty przetwarzają dane na podstawie umów zawartych z Administratorem i wyłącznie zgodnie z poleceniami Administratora. Dane mogą również zostać udostępnianie podmiotom upoważnionym do tego na podstawie przepisów prawa. Pani/Pana dane osobowe nie będą przekazywane do państwa trzeciego/organizacji międzynarodowej. Pani/Pana dane osobowe będą przechowywane przez okres niezbędny dla świadczenia usługi lub w przypadku wyrażenia zgody na przetwarzanie danych osobowych – do momentu wycofania zgody. Posiada Pani/Pan prawo dostępu do treści swoich danych oraz prawo ich sprostowania, usunięcia, ograniczenia przetwarzania, prawo do przenoszenia danych, prawo wniesienia sprzeciwu. Wyrażona przez Pana/Panią zgoda może zostać wycofana w każdej chwili. Wycofanie zgody nie wpłynie na zgodność z prawem przetwarzania Pana/Pani danych osobowych, którego dokonano na podstawie wyrażonej przez Pana/Panią zgody, przed jej wycofaniem. Oświadczenie o wycofaniu zgody na przetwarzanie Pana/Pani danych osobowych należy kierować na adres e-mail personal-da@loreal.com. Przysługuje Pan/Pani prawo wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych, gdy uzna Pani/Pan, iż przetwarzanie danych osobowych Pani/Pana dotyczących narusza przepisy RODO. Podanie przez Pana/Panią danych osobowych jest dobrowolne, ale niezbędne dla realizacji wskazanych celów.

        <br>Informujemy, że zgoda na przetwarzanie danych osobowych do wskazanych powyżej celów może zostać wyrażona przez osobę, która ukończyła 16 lat.
        <br>Aby dowiedzieć się więcej o tym, w jaki sposób wykorzystywane są dane osobowe należy  zapoznać się z naszą <a href="/download-file/salonexpert-polityka-prywatnosci" target="_blank" >Polityką prywatności</a>.

    </small>

  </p>

  <button class="btn" type="submit" [disabled]="submitedForm">Wyślij</button>

</form>
